const redirectSectionForm = document.getElementById('prepaid_redirect');

function setPrepaidRedirectAction(){
const redirectForm = redirectSectionForm ? redirectSectionForm.querySelector('form') : null;
const redirectUatUrl = redirectSectionForm.dataset?.uatUrl; //for www2
const redirectProdUrl = redirectSectionForm.dataset?.prodUrl; // for prod www
const prodHostname = new URL(prodUrl).hostname;
const emailInput = redirectForm.querySelector('input[type="email"]');
const checkbox = redirectForm.querySelector('input[type="checkbox"]');
const submitBtn = redirectForm.querySelector('input[type="submit"]');
redirectForm.action = getHostName() === prodHostname ? redirectProdUrl : redirectUatUrl;
const langInput = redirectForm.querySelector('input[name="lang"]');
const {lang} = getCountryAndLanguage();
if(langInput && lang) langInput.value = lang;
setupFormValidation(emailInput, checkbox, submitBtn);
const contactForminput = document.getElementById('contact-email-id');
contactForminput.addEventListener('input', () => {
  contactForminput.setAttribute('value', contactForminput.value);
});
}

function setupFormValidation(emailInput, checkbox, submitBtn) {
    emailInput.addEventListener("input", () => toggleSubmitState(emailInput, checkbox, submitBtn));
    checkbox.addEventListener("change", () => toggleSubmitState(emailInput, checkbox, submitBtn));
    toggleSubmitState(emailInput, checkbox, submitBtn);
}

function toggleSubmitState(emailInput, checkbox, submitBtn) {

  const emailEntered = emailInput?.value?.trim() !== "";
  const isEmailValid = emailInput?.value?.match(mailformat);
    
    if (isEmailValid && checkbox.checked) {
      submitBtn.classList.remove('disabled');
      submitBtn.disabled = false;
    } else {
      submitBtn.classList.add('disabled');
      submitBtn.disabled = true;
    }

    if (emailInput.classList.contains("contact-info-email-id") && emailEntered) {
      if (!isEmailValid) {
        showValidationMessage(emailInput);
      } else {
        hideValidationMessage(emailInput);
      }
    }
}

if(redirectSectionForm){
    setPrepaidRedirectAction();
}

